module.exports = __webpack_public_path__ + "img/disposable-items.9a72398f.png";